/**
 * Public news/ticker: hide legacy UO-branded notices.
 * UOC / ORBC copy is current and must stay.
 */
export function isUoBrandedAnnouncement(row: {
  title?: string | null;
  body?: string | null;
  notice_title?: string | null;
  notice_text?: string | null;
}): boolean {
  const text = [row.title, row.body, row.notice_title, row.notice_text]
    .filter((v): v is string => typeof v === 'string' && v.length > 0)
    .join('\n')
    .replace(/<[^>]+>/g, ' ')
    .normalize('NFKC')
    .replace(/UOC|ORBC/gi, '');
  return /UO/i.test(text);
}
